import { useColorScheme } from '@mui/material/styles';

// The colour scheme actually on screen (DWLF-298). With CSS-variable themes, theme.palette.mode is
// always the default scheme, so mode-dependent logic reads this instead.
export default function useIsDark() {
  const { mode, systemMode } = useColorScheme();
  return (mode === 'system' ? systemMode : mode) !== 'light';
}
